import { IntpWebsite } from '@va/aaas/shared/types';
import { apiGateway } from '@va/api-client';

export const get3asWebsiteByVisaId = async (id: string) => {
  const { payload } = await apiGateway.get<{ payload: IntpWebsite }>(`/v2/3as/internal/websites/${id}`);
  return payload;
};
